import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface PerpsSettingsStore {
  hasSeenIntro: boolean
  hasApprovedBuilderFee: { [key: string]: boolean }
  setHasApprovedBuilderFee: (wallet: string) => void
  setHasSeenIntro: (hasSeen: boolean) => void
}

export const createPerpsSettingsStore = (storage: StateStorage) =>
  createStore<PerpsSettingsStore>(
    storage,
    (set, get) => ({
      hasSeenIntro: false,
      hasApprovedBuilderFee: {},
      setHasApprovedBuilderFee: (wallet) => {
        const { hasApprovedBuilderFee } = get()

        set({ hasApprovedBuilderFee: { ...hasApprovedBuilderFee, [wallet]: true } })
      },
      setHasSeenIntro: (hasSeenIntro) => {
        set({ hasSeenIntro })
      },
    }),
    {
      persist: {
        name: 'activitySettings',
      },
    }
  )
